module.exports = __webpack_public_path__ + "img/linkedin.11efa12c.svg";